const history = {
  title: "自分のプロジェクト",
  upgradeBtn: "アップグレード",
  subTitle: "ファイルのダウンロードを忘れないでください。24時間以降自動に削除します。",
  MAgo: "{{num}}分間前",
  HAgo: "{{num}}時間前",
  DAgo: "{{num}}時間前",
  justNow: "先ほど",
  originalFile: "オリジナルファイル",
  selectAllBtn: "全選択",
  emptyTips: "プロジェクトはまだありません。<1>編集する</1>",
  deleteTips: "消去してもよろしいですか？",
};

export default history;
